import React, { useState, useEffect } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Link } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import helperNumber from "../../../helpers/numbers";
import mobileHelper from "../../../helpers/mobile";
import helperTime from "../../../helpers/time";
import user from "../../../messages/user";
import TitleBar from "../../partials/content/TitleBar";
import Pagination from "../../partials/content/Pagination";

export default function AllUserCustomerCoWorker() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [userID, setUserID] = useState();

  useEffect(() => {
    getUserCustomerCoWorker();
  }, []);

  useEffect(() => {
    getUserCustomerCoWorker();
  }, [currentPage, countItemPerPage, userID]);

  const getUserCustomerCoWorker = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetUserCustomerCoWorker =
      await sendRequestGetUserCustomerCoWorker(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetUserCustomerCoWorker) {
      return;
    }
    setCountPage(resultSendRequestGetUserCustomerCoWorker.count_page);
    setUsers(resultSendRequestGetUserCustomerCoWorker.users);
  };

  const sendRequestGetUserCustomerCoWorker = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let result;
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/user/customer-coworker-paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (userID) {
      searchFilterQuery = `${searchFilterQuery}&user_id=${userID}`;
    }

    return searchFilterQuery;
  };

  const generateTable = () => {
    return (
      <>
        <div className="pb-2 ">
          <Link className="btn btn-success  " to="/user/add-customer-coworker">
            <i className="fa fa-plus ml-1"></i>
            اضافه کردن کاربر
          </Link>
        </div>
        <div class="container-fluid">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در شماره کاربر</label>
              </div>
              <div>
                <input
                  onWheel={(event) => event.currentTarget.blur()}
                  onKeyUp={(e) => setUserID(parseInt(e.target.value))}
                  className="form-control"
                  type="number"
                  placeholder="شماره کاربر را در اینجا وارد کنید "
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-all-users m-0 ">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کاربر</td>
                <td>نام</td>
                <td>نام خانوادگی</td>
                <td>ایمیل</td>
                <td>شماره موبایل</td>
                <td>موجودی</td>
                <td>تاریخ ثبت نام</td>
                <td>تاریخ آخرین ورود کاربر</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>{generateRowTable(users)}</tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile-customer-coworker/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const enterUserProfile = async (userID) => {
    let token = await sendRequestGetTokenUser(userID);
    if (!token) {
      return;
    }

    localStorage.removeItem("token");
    localStorage.setItem("token", token);
    const url = process.env.REACT_APP_DOMAIN;
    window.location.replace(url);
  };

  const generateRowTable = (users) => {
    return users.map((user, index) => {
      return (
        <tr>
          <td>{helperNumber.toPersianNum(index + 1)}</td>
          <td>{helperNumber.toPersianNum(user.id)}</td>
          <td>{user.first_name}</td>
          <td>{user.last_name}</td>
          <td>{user.email}</td>
          <td dir="ltr">
            {helperNumber.toPersianNum(mobileHelper.formatMobile(user.mobile))}
          </td>
          <td className="letter-spacing-finance-number">
            {helperNumber.toPersianNum(
              helperNumber.toFormatFinanceNumber(user.charge)
            )}
          </td>
          <td>
            {helperNumber.toPersianNum(
              helperTime.convertGregorianToJalali(user.created_at) +
                " " +
                user.created_at.split(" ")[1]
            )}
          </td>
          <td>
            {user.last_login_at != null
              ? helperNumber.toPersianNum(
                  helperTime.convertGregorianToJalali(user.last_login_at) +
                    " " +
                    user.last_login_at.split(" ")[1]
                )
              : ""}
          </td>
          <td>
            <div className="text-nowrap">
              <span className="pl-2">
                <Link
                  to={`/user/customer-coworker-info/${user.id}`}
                  className="btn btn-info"
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>

              <span className="pl-2">
                <Link
                  href="# "
                  className="btn btn-warning"
                  to={`/report/coworker/campaign/${user.id} `}
                >
                  <i class="fa fa-chart-line"></i>
                </Link>
              </span>

              <span className="pl-2">
                <span
                  className="btn btn-success"
                  onClick={(e) => {
                    e.preventDefault();
                    enterUserProfile(user.id);
                  }}
                >
                  <i className="fa fa-sign-in-alt"></i>
                </span>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const generateCoworkerDoseNotHaveAnyCustomer = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img class="img-fluid" src="/assets/img/do-not-have-campaigns.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر هیچ کاربری ندارید :(</p>
          <p>برای شروع کار یک کاربر بسازید.</p>
          <div className="text-center text-md-right pt-2">
            <Link className="btn btn-success" to="/user/add-customer-coworker">
              <i className="fa fa-plus ml-1"></i>
              اضافه کردن کاربر
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar activeItem="user-customer-coworker" />

      <div className="content-wrapper">
        <TitleBar title="کاربران مشتریان همکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {users.length == 0 && userID == null
                ? generateCoworkerDoseNotHaveAnyCustomer()
                : generateTable()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
